import React from 'react'
import { getEmbedOptions } from '../helpers/acast'
import { useConsentGiven } from 'common/hooks/useConsentGiven'
import { ConsentLevel } from 'common/data/consent/consent.redux'
import { ConsentFallback } from 'component-library/tracking/ConsentFallback/ConsentFallback'

export interface Props {
    link: string
    theme?: 'light' | 'dark'
}

export const ACast: React.FC<Props> = (props: Props) => {
    const consentGiven = useConsentGiven({
        consentRequiredLevel: ConsentLevel.Analytics | ConsentLevel.Advertising,
    })

    if (!consentGiven) {
        return <ConsentFallback />
    }

    const options = getEmbedOptions(props.link, props.theme)
    return (
        <iframe
            width={'100%'}
            height={`${options.height}px`}
            frameBorder={0}
            src={options.src}
            sandbox={'allow-same-origin allow-popups allow-scripts'}
        />
    )
}
